import _ from 'underscore';
import $ from 'jquery';

import 'visibilityjs/lib/visibility.fallback.js';
import Visibility from 'visibilityjs';

import './utils/underscore-mixins';
import './utils/api-sync';

import { eventBus } from './state-manager/event-bus';
import { state } from './state-manager/state-model';
import { AppView } from './app-view';
import { starterGuide } from './starter-guide/starter-guide-view';
import { checkAXInstalled, tryUpdateAX } from './game-starter/launch';
import { redirectToInstallAX } from './game-starter/redirect-to-install-ax';
import { initBannerSlider } from './home-ui/banner-slider';

$(function () {
  initBannerSlider(); // 포커홈 상단 배너

  var app = new AppView({ model: state });

  app.eventBus = eventBus;

  // 포커몰, 출석부 등 다른 모듈에서 호출할 때
  $(document).on('app:refresh', function () {
    eventBus.trigger('app:refresh');
  });

  $(document).on('app:runGame', function () {
    eventBus.trigger('app:runGame');
  });

  $(document).on('app:runGamePchipCh', function () {
    eventBus.trigger('app:runGame', {
      ssn: 156,
      channel: 9
    });
  });

  $(document).on('app:authenticate', function () {
    eventBus.trigger('app:authenticate');
  });

  eventBus.on('app:gameLaunching', function () {
    if ($.browser.msie) {
      app.message.show('게임 실행 안내', ['게임을 실행하고 있습니다.', '잠시만 기다려 주십시오.']);
      _.delayed(function () {
        app.message.hide();
      }, 5000);
    } else {
      starterGuide.show();

      $(window).one('blur', function () {
        _.delayed(function () {
          starterGuide.hide();
        }, 1000 * 2);
      });

      _.delayed(function () {
        starterGuide.hide();
      }, 1000 * 60); // 1분 후에 무조건 닫음
    }
  });

  /**
   * NOTE: IE일 경우만 실행,
   * 1. AX가 설치되어 있으면 버전 체크 후 구 버전이라면 최신 AX로 업데이트 하고
   * 2. 설치되어 있지 않으면 설치 안내 페이지로 리다이렉트 한다.
   */
  if (checkAXInstalled()) {
    tryUpdateAX();
  } else {
    redirectToInstallAX();
  }

  // 웹사이트를 유저가 보고 있다면 주기적으로 유저 정보 갱신 (IE에서는 창이 focus, blur 일 때 동작)
  Visibility.every(1000 * 60 * 3, 1000 * 60 * 6, function () {
    eventBus.trigger('app:refresh');
  });

  /**
   * 캐주얼 게임군에서 포커 게임 실행할 때 사용
   * poker.pmang.com/7poker#run=[게임명] 으로 게임을 바로 실행
   */
  var qs = new URLSearchParams(location.hash);
  var toRun = qs.get('#run');

  if (toRun === 'poker') {
    eventBus.trigger('app:runGame');
    location.hash = '';
  } else if (toRun === 'slot') {
    eventBus.trigger('app:runGame', { ssn: 228, gameInfoSrl: 1 });
    location.hash = '';
  } else if (toRun === 'sudda') {
    eventBus.trigger('app:runGame', { ssn: 179, gameInfoSrl: 1 });
    location.hash = '';
  }

  // 크롬, 사파리에서 back, forward 버튼 캐싱 방지
  // 서버에서 캐시 헤더 설정도 필요
  $(window).on('unload', function () {});

  // 글로벌 노출
  window.__APP__ = app;
});
